function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Wallet({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5.348a.83.83 0 00-.83-.828H5.06c-.585 0-1.055.467-1.06 1.048.005.58.475 1.047 1.06 1.047H17V5.348zm.848 3.267H5.06c-.373 0-.73-.066-1.06-.188v10.245a.83.83 0 00.83.828h14.33a.83.83 0 00.83-.828v-1.936h-3.67a1 1 0 01-1-1V12a1 1 0 011-1h3.67V9.453a.83.83 0 00-.83-.828h-1.17c-.048 0-.096-.003-.142-.01zM19 5.348v-.01a2.83 2.83 0 00-2.83-2.828H5.202a1.009 1.009 0 00-.142-.01A3.056 3.056 0 002 5.578v13.094A2.83 2.83 0 004.83 21.5h14.33a2.83 2.83 0 002.83-2.828v-2.794c.007-.046.01-.094.01-.142V12c0-.048-.003-.096-.01-.143V9.454a2.83 2.83 0 00-2.83-2.828H19V5.348zm.99 9.388V13h-2.67v1.736h2.67z",
    fill: props.color || "#222"
  }));
}

const MemoWallet = React.memo(Wallet);
export default MemoWallet;